import {Customer} from "../../../customers/model/Customer";
import {CustomerInfoOptions} from "../../model/CustomerInfoOptions";
import {IComponentController} from "angular";

export class IEditableField implements IComponentController{
    protected fieldName?: string;
    protected customer?: Customer;
    protected isRequired?: boolean;
    protected options?: CustomerInfoOptions;
    protected inputValue?: any;
    protected pattern?: any;
    protected errorMessage?: string;
}